<template>
    <div>

      <section  class="navbarsection" style="margin-top: -50px;">
            <div class="txtdata">
              <h1  style="padding-top: 200px;"></h1>
            </div>
              <div class="videosection" >
                <div  v-show="pvisvideo === true && pvpictureimage === false ">
                  <Transition class="transition thing">
                    <video-background 
                      playbackRate=0.2
                      :src="src"
                      :poster="poster"
                      :class="`thing playercss`"
                      :style="`height: 600px;`">
                    </video-background>
                  </Transition>
                </div>
              
                  <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                  </div>
        
                  <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                  v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
         
            </div>
            <div class="overlay"></div>
            <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
              <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
            </div>
          </section>
      
    
     <div class="maincontainer">
        <div class="row align-items-start ">
          <div class="col col-xs-12 col-sm-12">
            <div class="downloadpdf"><span class="dwlpdf" @click.prevent="downloadPdf()">DOWNLOAD PDF <i class="fa-regular fa-circle-down" @click.prevent="downloadPdf()"></i></span>
              
              <span class="dwlpdf dwlpdf1" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                APPLY <i class="fa-regular fa-circle-down" @click.prevent></i></span>
              <br><hr></div>
            <div v-html="getjobinfo" class="jobposting"></div>
          </div>
        </div>
    </div>
 
      <section class="bottomsec">
        <div>
          <hr class="hrclass"/>
          <span v-html="careerbottommsg" class="hrspantext">
  
          </span>
        </div>
         
      </section>
      <section style="height: 40px;">
      </section>


<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade formatmodal" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalheadingformat" id="staticBackdropLabel"><span>JD #: </span>{{ getjobrefnumber }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <FormdataUpload :myjobid="getjobid" />

            </div>
             
          </div>
        </div>

      </div>
      <div class="footertextformat">
        <div class="footerinnertext">
          GOOD LUCK!!!
        </div>
      </div>
    </div>
  </div>
</div>




    </div>
  </template>
  
  <script>

  // import BreadCrumbs from '@/components/BreadCrumbs.vue';
  require('@/globalDeclare.js');
  require('@/assets/css/pannellium-2.5.css');
  require('@/assets/css/video-js.css');
  import axios from 'axios';
  import { useRoute, useRouter } from 'vue-router'
  import FormdataUpload from '@/components/FormdataUpload.vue';
  
  const router = useRouter()
  const route = useRoute()
  
  
  export default {
    name: 'AboutView',
    components: {
    FormdataUpload
  },
  data() {
    return {
    videoimage: [],
    imagetext: '',
    src: '',
    playrate: '',
    poster: '',
    // pvwebm: '',
    // pvmp4: '',
    pvstyle: '',
    pvsrc: '',
    pvisvideo: false,
    pvpanorama1: '',
    pvpanorama2: '',
    pvpanorama3: '',
    pvhotspot1: '',
    pvhotspot2: '',
    pvhotspot3: '',
    showVideo: false,
    showPanorama: false,
  
    breadcrumbsinfo: [],

    getjobinfo: '',
    getpdflink: '',
    getjobrefnumber: '',

    filenames: [],
    images: [],

    getjobid: '',
    myPicUrl: ''

  
 
    }
  },

  methods: {
    downloadPdf(){
      const link = document.createElement("a");
      let pdfpath = this.myPicUrl + this.getpdflink
      link.href = pdfpath;
      console.log(this.getpdflink)
      link.setAttribute("download", pdfpath);
      link.click();
    }
  },
  computed: {
  routeName() {
    return this.$route.name;
    console.log(this.$route.name)
  },
  
},
  async mounted() {
    this.myPicUrl = myUrlPath
    let showImage = Boolean
    showImage = false
    
    let vm = this
    let jobpostingid = vm.$route.params.jobid

    this.getjobid = jobpostingid

  await axios.get('allpagespv/jobposting').then(
      response => {
        this.videoimage = response.data 

      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
  
        // let pvisvideo1 = this.videoimage.pvisvideo
        // this.pvisvideo = pvisvideo1
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -237.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.6,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                    hotSpots: [
                        {
                            pitch: 4,
                            yaw: 21.8,
                            type: "scene",
                            sceneId: "anotherhotspot",
                            text: this.pvhotspot1,
                        }
                    ]
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "lasthotspot",
                              text: this.pvhotspot2,
                          }
                      ]
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "hotspotoffice",
                              text: this.pvhotspot3,
                          }
                      ]
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
    })
    .catch((error) => {
          console.log(error)
        })
    
  //------------breadcrumbs mappings info---------------
  await axios.get('getbreadcrumbsinfo/jobposting').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })  

   //------------Unique job posting---------------
  await axios.get(`getuniquejob/${jobpostingid}`).then(
    response => {
        this.getjobinfo = response.data[0].jobinfo
        this.getpdflink = response.data[0].jobpdf
        this.getjobrefnumber = response.data[0].jobrefnumber
    })
    .catch((error) => {
        console.log(error)
}) 
  },
  
  }
  </script>
  
  <style scoped>
  .stockcards {
    padding-top: 200px;
  }
  
  .container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: .2fr 1.2fr .2fr;
    grid-template-areas: 
    "nav nav nav" 
    "main main main" 
    "footer footer footer";
    grid-gap: 0.2rem;
    font-family: "Inter", sans-serif;
    font-size: 800;
    font-size: 12px;
    color: #234234;
    text-align: center;
  }
  
  html { 
    height: 100%;
    margin:0px;
    background: url('../assets/slide-5.jpg') no-repeat center center;
    background-size: cover;
    background-attachment: fixed;
  }
  
  main {
    background: white;
    grid-area: main;
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-radius: 0px;
    margin-top:-5px;
  }
  

  .bottomsec{
    font-size: 18px;
    text-align: justify;
    border-top: solid thin grey;
    padding: 100px;
  }
  .hrspantext {
    padding-top: 10px;
  }

  .maincontainer {
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 200px;
  }
 
  .downloadpdf {
    float: right;
    padding-right: 100px;
    width:100%;
    text-align: right;
  }
  .jobposting {
    margin-top: 40px;
  }
  .fa-circle-down {
    font-size: 30px;
    color: orangered;
    padding-left: 20px;
    cursor: pointer;
  }
  .dwlpdf {
    font-weight: bold;
    font-size: 20px;
    color: rgb(91, 113, 153);
    cursor: pointer;
  }
  .dwlpdf1 {
 padding-left: 150px;
  }
  .divcssformat {
    padding: 20px;
  }
.breadcrumbcss {
  margin-top: 90px;
}
.modal-header {
  background-color: #003;
  color: whitesmoke;
}
.footerinnertext{
  text-align: center;
  padding: 20px;
 
}
.footertextformat {
  background-color: #003;
  color: whitesmoke;
  margin-top: 20px;
}
.btn-close {
  background-color: white;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
  /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .bottompagemsg{
      margin-bottom: -350px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
  
    .stockcss {
      width: 98%;
      margin-top: 100px;
      margin: 0 auto;
      padding: 20px;   
      }
    .pantopsection {
      margin-top: 100px;
     }
 
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
    .bottompagemsg{
      margin-bottom: -200px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
    .stockcss {
      width: 98%;
      margin-top: 100px;
      margin: 0 auto;
      padding: 20px;   
      }
    .pantopsection {
      margin-top: 100px;
     }
 
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
    .bottompagemsg{
      margin-bottom: -200px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
 
    .pantopsection {
      margin-top: 250px;
     }
   }
  
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
    .bottomsec{
      text-align: justify;
      padding-left: 100px;
      padding-right: 100px;
    }
    .panimagesize {
      margin-top: 130px;
    }
    .interestcss {
      padding: 100px;
    }

   }
  
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
    .bottompagemsg{
      margin-bottom: -100px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
    .pantopsection {
      margin-top: 100px;
    }
 
    .maincontainer {
      padding-right: 200px; 
      padding-left: 200px;   
      }
   } 
  
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1400px) {
    .txtdata {
      margin-top: -100px;
      margin-bottom: 100px;
      width: 600px;
    }
    .stockcss {
      width: 68%;
      margin-top: 100px;
      margin: 0 auto;
      padding: 20px;   
      }
    .pantopsection {
      margin-top: 100px;
     }
    } 
  
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1600px) {
  
  .maincontainer {
    padding-right: 300px; 
    padding-left: 300px;   
    }
  .pantopsection {
    margin-top: 100px;
   }
  } 
    
  </style>
  